export default __webpack_public_path__ + "static/media/logo-90-w.5eedb7ff.svg";